/* ═══════════════════════════════════════════════════════════
   FEMME — bmm-custom.js
   Custom JavaScript for Heritage v3.4.0
   Version: 1.5 (Announcement hidden; Heritage marquee.js handles shipping marquee)
   Last Updated: March 3, 2026
   ═══════════════════════════════════════════════════════════
   Loaded with defer. No render-blocking.
   Heritage handles: slideshow, marquee, drawer, sticky, cart.
   This file handles: scroll reveal, countdown (Phase 2),
   tab filter (Phase 2), coupon copy (Phase 2),
   custom carousels (Phase 3).
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Scroll Reveal (IntersectionObserver) ── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.bmm-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function(el) { el.classList.add('bmm-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bmm-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Countdown Timer (Phase 2) ── */
  function initCountdown() {
    var timers = document.querySelectorAll('[data-bmm-countdown]');
    if (!timers.length) return;
    timers.forEach(function(timer) {
      var endDate = new Date(timer.dataset.bmmCountdown).getTime();
      if (isNaN(endDate)) return;
      var expiredMsg = timer.dataset.bmmExpired || 'Sale Has Ended';
      var daysEl = timer.querySelector('[data-bmm-days]');
      var hrsEl = timer.querySelector('[data-bmm-hours]');
      var minsEl = timer.querySelector('[data-bmm-mins]');
      var secsEl = timer.querySelector('[data-bmm-secs]');
      if (!daysEl || !hrsEl || !minsEl || !secsEl) return;
      function tick() {
        var diff = endDate - Date.now();
        if (diff <= 0) {
          timer.innerHTML = '<p class="bmm-countdown__expired">' + expiredMsg + '</p>';
          return;
        }
        daysEl.textContent = String(Math.floor(diff / 86400000)).padStart(2, '0');
        hrsEl.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
        minsEl.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        secsEl.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
        requestAnimationFrame(function() { setTimeout(tick, 1000); });
      }
      tick();
    });
  }

  /* ── Category Tab Filter (Phase 2) ── */
  function initCategoryTabs() {
    var tabContainers = document.querySelectorAll('[data-bmm-tabs]');
    if (!tabContainers.length) return;
    tabContainers.forEach(function(container) {
      var tabs = container.querySelectorAll('[data-bmm-tab]');
      var section = container.closest('section');
      var grid = section ? section.querySelector('[data-bmm-filterable]') : null;
      if (!grid) grid = container.nextElementSibling;
      if (!tabs.length || !grid) return;
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          var filter = tab.dataset.bmmTab;
          tabs.forEach(function(t) { t.classList.remove('bmm-tab--active'); });
          tab.classList.add('bmm-tab--active');
          grid.querySelectorAll('[data-bmm-tags]').forEach(function(card) {
            card.style.display = (filter === 'all' || card.dataset.bmmTags.indexOf(filter) !== -1) ? '' : 'none';
          });
        });
      });
    });
  }

  /* ── Coupon Copy (Phase 2) ── */
  function initCouponCopy() {
    document.querySelectorAll('[data-bmm-copy-coupon]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var code = btn.dataset.bmmCopyCoupon;
        if (!code) return;
        navigator.clipboard.writeText(code).then(function() {
          var orig = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(function() { btn.textContent = orig; }, 2000);
        });
      });
    });
  }

  /* ── Init ── */
  function init() {
    initScrollReveal();
    initCountdown();
    initCategoryTabs();
    initCouponCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();